
import React from 'react';
import LifeSkill from 'views/LifeSkill';

const LifeSkillPage = () => {
  return <LifeSkill/>;
};

export default LifeSkillPage;
